import { render, staticRenderFns } from "./product_info.vue?vue&type=template&id=376d22e6&scoped=true"
import script from "./product_info.vue?vue&type=script&lang=js"
export * from "./product_info.vue?vue&type=script&lang=js"
import style0 from "./product_info.vue?vue&type=style&index=0&id=376d22e6&prod&lang=stylus&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "376d22e6",
  null
  
)

export default component.exports